import {
  centerItemFlex,
  primaryColorWhite
} from "../../../utils/styles";

const customButtonStyles = {
  btnStyle: {
    fontFamily:
      '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    textTransform: "none",
    fontWeight: 500,
    letterSpacing: "0.3px",
    fontSize: "14px",
    lineHeight: 1.5,
    minWidth: "fit-content",
    height: "48px",
    padding: "12px 32px",
    borderRadius: "4px",
    cursor: "pointer",
    position: "relative",
    overflow: "hidden",
    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
    boxShadow: "none",
    border: "none",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: "-100%",
      width: "100%",
      height: "100%",
      background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)",
      transition: "left 0.5s ease",
    },
    "&:hover": {
      transform: "translateY(-2px) scale(1.02)",
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
      "&::before": {
        left: "100%",
      },
      "& .animateY1": {
        transform: "translateY(-100%)",
        opacity: 0,
      },
      "& .animateY2": {
        transform: "translateY(0)",
        opacity: 1,
      },
    },
    "&:active": {
      transform: "translateY(0) scale(0.98)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    },
    "&:disabled": {
      opacity: 0.6,
      cursor: "not-allowed",
      transform: "none",
      "&:hover": {
        transform: "none",
        boxShadow: "none",
      },
    },
  },
  btnInnerBox: {
    position: "relative",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
  },
  mainText: {
    display: "block",
    transition: "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.4s ease",
    fontSize: "14px",
    fontWeight: 500,
    letterSpacing: "0.3px",
    fontFamily:
      '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  mainText1: {
    fontSize: "14px",
    fontWeight: 500,
    letterSpacing: "0.3px",
    fontFamily:
      '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  gradientText: {
    background:
      "linear-gradient(90deg, #ff68cc 0%, #dc5fff 33%, #a080ff 67%, #7f99ff 100%)",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  subText: {
    display: "flex",
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    opacity: 0,
    transform: "translateY(100%)",
    transition: "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.4s ease",
    fontSize: "14px",
    fontWeight: 500,
    letterSpacing: "0.3px",
    fontFamily:
      '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    alignItems: "center",
    justifyContent: "center",
  },
  subText1: {
    fontSize: "14px",
    fontWeight: 500,
    letterSpacing: "0.3px",
    fontFamily:
      '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  loading: {
    width: "100%",
    ...centerItemFlex,
  },
  transparentBtn: {
    background: "transparent",
    border: "none",
    color: "inherit",
    "&:hover": {
      background: "rgba(0, 0, 0, 0.05)",
      boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
    },
  },
  borderedBtn: {
    background: "transparent",
    border: "1px solid currentColor",
    color: "inherit",
    "&:hover": {
      background: "rgba(0, 0, 0, 0.05)",
      borderColor: "currentColor",
      boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
    },
  },
  darkBtn: {
    color: primaryColorWhite,
    background: "#010101",
    "&:hover": {
      background: "#1a1a1a",
      boxShadow: "0 8px 24px rgba(1, 1, 1, 0.4)",
    },
    "&:active": {
      background: "#000000",
    },
  },
  secondaryBtn: {
    background: "transparent",
    border: "1px solid currentColor",
    color: "inherit",
    "&:hover": {
      background: "rgba(0, 0, 0, 0.05)",
      boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
    },
  },
} as const;

export default customButtonStyles;
